import React from "react";

const MainHeading = (props) => {
  const { heading } = props;
  return (
    <div>
      <span className="graphikFont text-3xl">{heading}</span>
    </div>
  );
};

export default MainHeading;
